import React, { FC } from 'react'
import { motion } from 'framer-motion'

interface MoodyAppStepsProps {
    moodyProjectData: any
}

const MoodyAppSteps: FC<MoodyAppStepsProps> = ({ moodyProjectData }) => {
    // Container animation variant
    const containerVariants = {
        hidden: { opacity: 0 },
        visible: {
            opacity: 1,
            transition: {
                staggerChildren: 0.2,
                delayChildren: 0.1
            }
        }
    }

    // Card animation variant - more dramatic slide-in
    const cardVariants = {
        hidden: {
            opacity: 0,
            y: 80,
            x: -20,
            rotateX: 10
        },
        visible: {
            opacity: 1,
            y: 0,
            x: 0,
            rotateX: 0,
            transition: {
                duration: 0.7,
                ease: [0.25, 0.1, 0.25, 1.0], // cubic-bezier custom easing
                type: "spring",
                stiffness: 100
            }
        }
    }

    // Enhanced hover animation variant
    const hoverVariants = {
        hover: {
            scale: 1.05,
            boxShadow: "0px 10px 20px rgba(0, 0, 0, 0.2)",
            transition: {
                duration: 0.4,
                ease: "easeInOut"
            }
        }
    }

    return (
        <div className='bg-blackDarkThemeSecondary p-4 sm:p-8 md:p-12 lg:p-24'>
            <motion.div
                className='grid grid-cols-1 sm:grid-cols-2 gap-4 sm:gap-6 md:gap-8 lg:gap-10'
                variants={containerVariants}
                initial="hidden"
                whileInView="visible"
                viewport={{ once: false, amount: 0.1 }}
            >
                {moodyProjectData.moodyProjectDetails.AppSteps.map((step: any, index: number) => {
                    return (
                        <motion.div initial={{
                            backgroundImage: 'none',
                            borderRadius: '0.75rem',
                        }}
                            whileHover={{
                                backgroundImage: `linear-gradient(109.56deg, #37B9AB 0%, #1E1E1E 59.14%)`,
                                borderRadius: '0.7rem',
                                padding: '1px',
                                scale: 1.05,
                                transition: { duration: 0.3 }
                            }}>
                            <motion.div
                                key={step.key}
                                className='bg-darkGreyPrimary rounded-xl flex items-start justify-between'
                                variants={cardVariants}
                                whileHover="hover"
                                whileTap={{ scale: 0.98 }}
                                {...hoverVariants}
                                custom={index}
                            >
                                <div className='p-4 sm:p-6 md:p-8 text-base sm:text-lg'>
                                    {step.title}
                                </div>

                                <motion.div
                                    className={`flex items-start justify-start text-4xl sm:text-5xl md:text-6xl lg:text-7xl bg-gradient-to-b from-[#31B9AB55] to-[rgba(152,255,18,0)] bg-clip-text text-transparent font-black relative -right-0 px-2`}
                                    animate={{
                                        opacity: [0.7, 1, 0.7],
                                        rotateY: [0, 5, 0],
                                        scale: [0.95, 1.02, 0.95],
                                    }}
                                    transition={{
                                        duration: 5,
                                        repeat: Infinity,
                                        ease: "easeInOut",
                                        times: [0, 0.5, 1]
                                    }}
                                >
                                    0{step.key}
                                </motion.div>
                            </motion.div>
                        </motion.div>
                    )
                })}
            </motion.div>
        </div>
    )
}

export default MoodyAppSteps
